import { PageHeader } from "UIPalette/PageHeader/PageHeader";
import { useTranslation } from "react-i18next";
import { BreathingExerciseSelector } from "./components/BreathingExerciseSelector/BreathingExerciseSelector";
import { BreathingExercise } from "shared/request/myHealthyAdvantageApi";
import { useState } from "react";
import { BreathingExerciseRunner } from "./components/BreathingExerciseRunner/BreathingExerciseRunner";
import { BreathingExerciseResults } from "./components/BreathingExerciseResults/BreathingExerciseResults";
import PageTitle from "UIPalette/PageTitle/PageTitle";
import { trackBtnClicks, trackEvents } from "core/monitoring/Events";
import { EventNames } from "core/monitoring/types/enums";
import { useAppReviewContext } from "core/state/AppReviewContext/AppReviewContext";

export const BreathingExercises = () => {
  const { t } = useTranslation();
  const { handlePositiveMoment } = useAppReviewContext();
  const [selectedExercise, setSelectedExercise] = useState<BreathingExercise | undefined>(undefined);
  const [exerciseDuration, setExerciseDuration] = useState(3);
  const [completed, setCompleted] = useState(false);

  const handleStartExercise = (exercise: BreathingExercise, duration: number) => {
    trackEvents(EventNames.BREATHING_EXERCISE_START, { value: exercise.name });
    setSelectedExercise(exercise);
    setExerciseDuration(duration);
  };

  const handleExerciseCancelled = () => {
    trackBtnClicks(`cancel_breathing_exercise`);
    setSelectedExercise(undefined);
  };

  const handleExerciseCompleted = () => {
    trackEvents(EventNames.BREATHING_EXERCISE_COMPLETE, { ...(selectedExercise && { value: selectedExercise.name }) });
    setCompleted(true);
  };

  const handleDone = () => {
    setCompleted(false);
    setSelectedExercise(undefined);
    handlePositiveMoment();
  };

  return (
    <>
      <PageTitle title={t("pageTitle.resources.breathingExercises")} />
      <PageHeader title={t("breathingExercises.heading")} hideForMobile />
      <p className="pb-3">{t("breathingExercises.headingParagraph")}</p>

      {!selectedExercise && <BreathingExerciseSelector onStartExercise={handleStartExercise} />}
      {selectedExercise && !completed && (
        <BreathingExerciseRunner
          exercise={selectedExercise}
          duration={exerciseDuration}
          onCancel={handleExerciseCancelled}
          onComplete={handleExerciseCompleted}
        />
      )}
      {completed && <BreathingExerciseResults exercise={selectedExercise!} duration={exerciseDuration} onDone={handleDone} />}
    </>
  );
};
